import * as React from 'react';
import {tokens} from '../../tokens';
import {useUiConfig} from '../../providers/UiConfigProvider';
import {DialogDesktop} from './Dialog.desktop';
import {DialogMobile} from './Dialog.mobile';
import {DialogConfig} from './DialogConfig';

/**
 * Dialogs are a form of overlay that represent a focused conversation between the application and the user.
 */
export const Dialog = DialogConfig.createView(
  (props) => {
    const uiConfig = useUiConfig();
    const isSmallScreen = !!uiConfig?.isSmallScreen;
    const isTouch = !!uiConfig?.isTouch;
    const enabledBottomSheets = !!uiConfig?.enableBottomSheets;

    return isTouch && isSmallScreen && enabledBottomSheets ? (
      <DialogMobile {...props} />
    ) : (
      <DialogDesktop {...props} />
    );
  },
  {
    variants: {
      size: {
        small: {
          css: {'--dialog-width': '368px'},
        },
        medium: {
          css: {'--dialog-width': '496px'},
        },
        large: {
          css: {'--dialog-width': '648px'},
        },
        xlarge: {
          css: {'--dialog-width': '944px'},
        },
        full: {
          css: {
            '--dialog-width': `calc(100vw - ${tokens.space.xlarge})`,
          },
        },
      },
    },
    forward: {size: true},
  },
);
